import type { CSSProperties, HTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/cn";
import type { SpaceToken } from "./Stack";
import styles from "./Flex.module.css";

const gapClass: Record<SpaceToken, string> = {
  4: styles.gap4,
  8: styles.gap8,
  12: styles.gap12,
  16: styles.gap16,
  24: styles.gap24,
  36: styles.gap36,
};

export interface FlexProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
  direction?: "row" | "column";
  gap?: SpaceToken;
  align?: CSSProperties["alignItems"];
  justify?: CSSProperties["justifyContent"];
  wrap?: boolean;
}

export function Flex({
  children,
  className,
  direction = "row",
  gap = 8,
  align,
  justify,
  wrap = false,
  style,
  ...rest
}: FlexProps) {
  return (
    <div
      className={cn(
        styles.flex,
        direction === "row" ? styles.row : styles.column,
        gapClass[gap],
        wrap && styles.wrap,
        className,
      )}
      style={{
        ...style,
        ...(align ? { alignItems: align } : {}),
        ...(justify ? { justifyContent: justify } : {}),
      }}
      {...rest}
    >
      {children}
    </div>
  );
}
